export default {
  title: 'Terminy',
  type: 'object',
  properties: {
    selectedTerms: {
      title: 'Terminy',
      type: 'array',
      items: {
        type: 'object'
      },
      validFunc: '$external.requiredLength === $value.length'
    }
  }
};
